import React from 'react'
import { Container, PageTitle } from '~/shared/ui/Layout'
import { PageContainer } from '~/shared/ui/Layout'
import RoutesTabs from '~/shared/ui/RoutesTabs'
import { useConfigTabs } from './useConfigTabs'

function SettingsPage() {
  const configTabs = useConfigTabs()

  return (
    <PageContainer title='Настройки'>
      <RoutesTabs
        parentPath='/settings'
        config={configTabs}
        parentContent={
          <Container isHeader>
            <PageTitle>Настройки</PageTitle>
          </Container>
        }
      />
    </PageContainer>
  )
}

export default SettingsPage
